import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import IconButton from '../IconButton';

interface TitleProps {
  title?: string;
  onClose?: () => void;
}

const Title = ({ title, onClose }: TitleProps) => {
  const { t } = useTranslation();

  if (!title) return null;

  return (
    <DialogTitle>
      <div>
        <Typography variant='h4' data-test-id='modal-title'>
          {t(title)}
        </Typography>
      </div>
      {onClose ? (
        <IconButton
          title={t('close')}
          aria-label='close'
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default Title;